var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ctn"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.head),expression:"head"}],staticClass:"ctn-head"}),_c('div',{staticClass:"ctn-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }